enum TextDirection {
    LTR = 'ltr',
    RTL = 'rtl',
}

export default TextDirection;
